import React, {FC, memo, useMemo} from 'react';
import {generateRoutePath} from '@epic-core/common';
import {RouteComponentProps, withRouter} from 'react-router';
import {withLocalization} from 'epic-localization/src/context/LocalizationContext';

import {TOUR_STEPS} from './tourSteps';
import {useFnGamesTour} from '../FnGamesTourProvider';
import TourModal from '../../../components/tour-modal/TourModal';

export interface FnGamesTourProps extends RouteComponentProps {
    getMessage: (code: string, args?: any[]) => string;
}

const FnGamesTour: FC<FnGamesTourProps> = ({getMessage, history, location}: FnGamesTourProps) => {
    const {open: isShowTour = false, onFinish} = useFnGamesTour();

    const steps = useMemo(
        () =>
            TOUR_STEPS.map(([title, description, image]) => ({
                title: getMessage(title),
                description: getMessage(description),
                image
            })),
        [getMessage]
    );

    const handleComplete = () => {
        onFinish();

        if (!location.pathname.includes('fortnite-games')) {
            history.push(generateRoutePath('fortnite-games'));
        }
    };

    return (
        <TourModal
            steps={steps}
            open={isShowTour}
            onClose={onFinish}
            onComplete={handleComplete}
            onSkip={onFinish}
        />
    );
};

export default memo(withLocalization(withRouter(FnGamesTour)));
